import React, { useEffect, useRef, useState } from 'react';
import { IPageData, IPageProps } from "../../interfaces/page-data";
import { Button, Space, Tooltip } from "antd";
import { Toast } from 'primereact/toast';
import HTTPService from "../../utils/makerequest";
import { DownloadOutlined, EditOutlined, UserAddOutlined } from '@ant-design/icons';
import { StateLoader } from '../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../interfaces/authentication';
import { IDropdownItem } from "../../AltisComponent/AltisDataGrid";
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { PersonelRol } from '../../interfaces/group';
import MUIDatagrid, { IMUIDataGridColumns } from '../../AltisComponent/MUIDataGrid';

interface IUserData {
  firstName: string,
  password?: string,
  personelStatus: PersonelRol
}

interface IUsers {
  count?: number,
  data?: IUserData[];
}

const PageUserSettings: React.FunctionComponent<IPageProps> = props => {
  const { onSetPage } = props;
  const [userData, setUserData] = useState<IUsers>({});
  const { t } = useTranslation();
  const dataGridRef = useRef<any>(null);
  const toast = useRef<any>(null);

  const pageData: IPageData = {
    title: t('user_settings'),
    loaded: true
  };

  const loader = new StateLoader();
  const userInfo: IAuthentication = loader.loadAuthState();

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]); // onSetPage, pageData


  const personelEnum = {
    [t('Sayman')]: 0,
    [t('Personel')]: 1,
    [t('Operator')]: 2,
    [t('Admin')]: 3,
    [t('AltisAdmin')]: 4,
    [t('AssetManager')]: 5
  };



  const roleEnum = {
    [t('Active_Personnel')]: 0,
    [t('Allowed_Personnel')]: 1,
    [t('Resigner_Personnel')]: 2,
    [t('Dismissed_Personnel')]: 3,
    [t('Retired_Personnel')]: 4
  };


  const UserFilter = (e?) => {
    const filters = e?.filters;
    if (filters?.personelStatus !== undefined) {
      if (filters.personelStatus === "" || filters.personelStatus === null) {
        delete filters.personelStatus;
      } else {
        filters.personelStatus = [Number(filters.personelStatus)];
      }
    }

    if (filters?.role !== undefined) {
      if (filters.role === "" || filters.role === null) {
        delete filters.role;
      } else {
        filters.role = [Number(filters.role)];
      }
    }
    var body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize,
      page: e?.page,
      ...filters,
    };



    HTTPService.POST(`/User/filters`, body).then((response) => {
      if (!response.data) {
        return;
      }
      if (response.status === 200) {
        setUserData(response.data);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });

  };

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [
      {
        title: t('company_name'),
        key: 'companyName',
        placeHolder: t('company_name'),
        isSorting: true,
      }
    ] : []),
    {
      title: t('email'),
      key: 'userEmail',
      placeHolder: t('email'),
      isSorting: true,
      align: 'center',
      headerAlign: 'center',
    },
    {
      title: t('firstName'),
      key: 'firstName',
      isSorting: true,
      placeHolder: t('firstName'),
      align: 'center',
      headerAlign: 'center',
    },
    {
      title: t('lastName'),
      key: 'lastName',
      isSorting: true,
      placeHolder: t('lastName'),
      align: 'center',
      headerAlign: 'center',
    },
    {
      title: t('role'),
      key: 'role',
      isSorting: true,
      placeHolder: t('role'),
      align: 'center',
      enumValues: personelEnum,
      headerAlign: 'center',
      render: (value) => {
        return <div>{t(value)}</div>
      }
    },
    {
      title: t('Personel Status'),
      key: 'personelStatus',
      isSorting: true,
      placeHolder: t('Personel Status'),
      enumValues: roleEnum,
      align: 'center',
      headerAlign: 'center',
      render: (value) => {
        return <div>{t(value)}</div>
      }
    },
    {
      title: t('operations'),
      key: 'operations',
      placeHolder: t('operations'),
      align: 'center',
      headerAlign: 'center',
      hideColumnMenu: true,
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 10 }}>
          <Space size={4}>
            <Tooltip title={t('update')}>
              <Button
                size='small'
                icon={<EditOutlined />}
                style={{ width: '60px', borderRadius: '70px', marginRight: '4px' }}
                onClick={() => {
                  window.location.replace('/admin/update-user/' + record.userId);
                }}
              >
              </Button>
            </Tooltip>

            <Tooltip title={t('debit_document')}>
              <Button
                size='small'
                icon={<DownloadOutlined />}
                style={{ width: '60px', borderRadius: '70px' }}
                onClick={() => {
                  window.location.replace('/admin/debit-management/' + record.userId);
                }}
              >
              </Button>
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-md-4 mb-3">
          <Button
            type="primary"
            shape="round"
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            size="middle"
            onClick={() => window.location.replace('/admin/add-user')}
          >
            <UserAddOutlined style={{ fontSize: 24 }} />
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('add_new_user')}
            </span>
          </Button>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <MUIDatagrid enableSelection={false} ref={dataGridRef} data={userData.data} total={userData.count} columns={columns} filterMode="server" onChange={UserFilter} />
        </div>
      </div>
    </>
  );
}

export default PageUserSettings;
